import { render, staticRenderFns } from "./MatchPairsSelectAnswer.vue?vue&type=template&id=141217dd&scoped=true&"
import script from "./MatchPairsSelectAnswer.vue?vue&type=script&lang=js&"
export * from "./MatchPairsSelectAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MatchPairsSelectAnswer.vue?vue&type=style&index=0&id=141217dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141217dd",
  null
  
)

export default component.exports